import { CCPayment } from "./CCPayment";
export default CCPayment;